<template>
  <div class="footer">

    <div>
      <!-- Nothing -->
    </div>

    <div>
      Une solution développée par
      <a href="http://iltr.fr" target="_blank">
        <img src="../assets/img/logo-iltr.png" alt="Logo ILTR">
      </a>
    </div>

    <div>
      Version {{ version }}
    </div>

  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  computed: {
    version () {
      return process.env.PORTAL_VERSION
    }
  }
}
</script>

<style scoped>
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  color: rgba(255, 255, 255, 0.8);
  background-color: #222222;
}

.footer div {
  flex: 1;
  padding: 0 1rem;
}

.footer div:first-child, .footer div:last-child {
  font-size: 0.8rem;
}

.footer div:first-child {
  text-align: left;
}

.footer div:last-child {
  text-align: right;
}

.footer div img {
  margin-left: 0.5rem;
  transform: translateY(0.1rem);
  height: 1rem;
}

/* IE10+ CSS styles */
/* @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .footer {
    display: block;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue